import { useAccordion } from "@material-tailwind/react";
import React, { useEffect, useMemo, useState } from "react";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import filter from "../../assets/images/icon_attendance/filter.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { getAttendanceDetail } from "../../core/service/api_attendance";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import moment from "moment";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import DatePicker from "react-datepicker";
import { StatsInvoice, StatsMessage } from "../common/home/Stats";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";

const ComponentAttendanceDetail = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const [child, setchild] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [startDate, setStartDate] = useState(new Date());
  const [showfilter, setShowfilter] = useState(false);
  let location: any = useLocation();
  const [openDetailHistory, setOpenDetailHistory] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const funBg = useMemo(() => {
    var str = "white";
    return "bg-" + str;
  }, []);
  const env = Config.BaseUrlDev;

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_a/image/get/" + photo + "/pas";
  };
  function onDismissDetailHistory() {
    setOpenDetailHistory(false);
  }

  const openSheetDetailHistory = async () => {
    setOpenDetailHistory(true);
  };
  const getData = async (date: string, callerId: string) => {
    dispatch(setLoading(true));
    getAttendanceDetail(date, callerId)
      .then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data);
        console.log(res.data, "dasf");
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  useEffect(() => {
    setchild(JSON.parse(location.state.data));
  }, []);

  useEffect(() => {
    if (child.callerId && location.state.date) {
      console.log(location.state.date);

      getData(moment(startDate).format("yyyy-MM-DD"), child.callerId);
    }
  }, [child]);
  return (
    <div className="bg-psp-primary pb-20">
      <StatsInvoice />
      <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        <div className="container h-full w-full">
          <div className="flex p-4">
            <BackButton />
            <div className="font-montserrat text-4xl my-2 font-bold">
              {t("HOME.menu.account")}
            </div>
          </div>
          <div className="bg-white p-3 rounded-2xl flex-row flex items-center mx-4 shadow w-auto">
            <img
              src={getProfileImage(child.photoUrl)}
              className="w-[7vh] h-[7vh] rounded-full flex-0"
            />
            <div className="flex flex-col grow ml-4">
              <h1 className="font-montserrat text-sm  font-bold">
                {child.name}
              </h1>
              <span className="font-montserrat text-xs font-medium">
                {t("INVOICE.nis")}: {child.callerId}
              </span>
            </div>
          </div>
          <div className=" flex-row flex mx-5 justify-around w-auto  mt-4">
            <div className="flex flex-row grow w-3/4">
              <h1 className="font-montserrat text-2xl font-medium text-[#B4B4B4]">
                {t("ATTENDANCE-DETAIL.subtitle")}
              </h1>
            </div>
            <div className="relative flex-col items-end  flex w-1/4">
              <img
                onClick={() => setShowfilter(!showfilter)}
                src={filter}
                className="w-10 h-10 relative rounded-full flex-0 cursor-pointer shadow-lg"
              />
              <div
                style={{
                  position: "absolute",
                  zIndex: 1,
                  opacity: !showfilter ? "0" : "1",
                  transition: "0.7s",
                  visibility: !showfilter ? "hidden" : "visible",
                }}
                className="px-4 py-2 top-12 flex-col border-1 flex bg-white shadow-2xl rounded-lg"
              >
                <h1 className="font-poppins font-medium text-sm text-black my-2">
                  {t("ATTENDANCE-DETAIL.filterDate")}:
                </h1>
                <div className="">
                  <DatePicker
                    className="w-full h-10 text-sm px-2 border-2 border-solid border-psp-gray rounded-lg"
                    selected={startDate}
                    onChange={(date: Date) => (
                      setStartDate(date),
                      getData(
                        moment(date).format("yyyy-MM-DD"),
                        child.callerId
                      ),
                      setOpenDetailHistory(false)
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2">
            {data.map((res: any, index: any) => (
              <div
                key={index}
                className="bg-white mt-2 px-2 py-2 mx-4 rounded-xl flex-row flex  items-center border border-black w-auto"
              >
                <div className="relative w-1/2 flex flex-row">
                  <div className="flex flex-col ">
                    <img
                      src={res.photo_url_masuk}
                      className="w-14 h-14 rounded-lg"
                    />
                  </div>
                  <div className="relative ml-4 flex flex-col justify-center ">
                    <h1 className="flex relative h-auto items-center font-montserrat text-xs font-medium ">
                      {res.shift_name}
                    </h1>
                    <h1 className="font-montserrat flex relative h-auto items-center font-medium text-psp-gray text-xs ">
                      {moment(res.tanggal_absen).format("LL")}
                    </h1>
                  </div>
                </div>
                <div className="flex relative w-1/2  flex-row justify-end">
                  <div className="relative w-1/4  flex flex-row justify-center">
                    <div className="flex flex-col items-center">
                      <h1 className="m-0 font-montserrat text-xs font-medium grow">
                        {t("ATTENDANCE-DETAIL.in")}
                      </h1>
                      <span className="font-montserrat  font-medium text-psp-gray text-xs flex-0">
                        {res.jam_absen_masuk}
                      </span>
                      <span
                        className={` font-montserrat  ${
                          res.sesi_ket_masuk === "NONE"
                            ? "bg-white"
                            : res.sesi_ket_masuk === "DATANG TERLAMBAT"
                            ? "bg-[#FF9C9C] text-white text-center"
                            : res.sesi_ket_masuk === "DATANG TEPAT"
                            ? "bg-cyan-400 text-white"
                            : "bg-cyan-400"
                        }  p-1 rounded-lg font-medium text-xs flex-0 capitalize`}
                        style={{ textTransform: "capitalize" }}
                      >
                        {res.sesi_ket_masuk === "NONE"
                          ? "-"
                          : res.sesi_ket_masuk}
                      </span>
                    </div>
                  </div>
                  <div className="relative w-1/4  flex flex-row justify-center">
                    <div className="flex flex-col items-center">
                      <h1 className="m-0 font-montserrat text-xs font-medium grow">
                        {t("ATTENDANCE-DETAIL.out")}
                      </h1>
                      <span className="font-montserrat  font-medium text-psp-gray text-xs flex-0">
                        {res.jam_absen_pulang}
                      </span>
                      <span
                        className={` font-montserrat  ${
                          res.sesi_ket_pulang === "NONE"
                            ? "bg-white"
                            : res.sesi_ket_pulang === "PULANG AWAL"
                            ? "bg-[#FF9C9C] text-white"
                            : res.sesi_ket_pulang === "PULANG TEPAT"
                            ? "bg-cyan-400 text-white"
                            : res.sesi_ket_pulang === "PULANG LEMBUR"
                            ? "bg-yellow text-white"
                            : "bg-white"
                        }  p-1 rounded-lg font-medium  text-xs flex-0 capitalize`}
                        style={{ textTransform: "capitalize" }}
                      >
                        {res.sesi_ket_pulang === "NONE"
                          ? "-"
                          : res.sesi_ket_pulang}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentAttendanceDetail;
